import HeaderDescriptionBlock from "@/components/HeaderDescriptionBlock";
import GridContainer from "@/components/common/GridContainer";
import {useIsDesktop} from "@/hooks/useDevice";
import {getCssSizeValue, getMapKey, groupArrayBySize} from "@/utils/utils";
import Tile from "@/components/TilesModule/variants/TilesContactCardsSimple/Tile";
import styled from "styled-components";
import {BREAKPOINTS} from "@/styles/themeSettings";

const Row = styled(GridContainer)`
	margin-bottom: ${getCssSizeValue(32, BREAKPOINTS.MOBILE)};
	row-gap: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		margin-bottom: ${getCssSizeValue(32, BREAKPOINTS.DESKTOP)};
		row-gap: ${getCssSizeValue(32, BREAKPOINTS.DESKTOP)};
	}
`

export default function TilesContactCardsSimple({data, paddings, headerDescription}) {
	const isDesktop = useIsDesktop()
	const tiles = data?.tiles || []
	const groupedTiles = groupArrayBySize(tiles, isDesktop ? 4 : data.tiles.length)

	return <section className={paddings}>
		<HeaderDescriptionBlock headerDescription={headerDescription} />
		{groupedTiles.map((group, index) => (
			<Row key={getMapKey(group, index)}>
				{group.map((tile, index) => <Tile key={getMapKey(tile, index)} tile={tile} />)}
			</Row>
		))}
	</section>
}
